import { render, staticRenderFns } from "./MainTemplate.vue?vue&type=template&id=0a616592&"
import script from "./MainTemplate.vue?vue&type=script&lang=js&"
export * from "./MainTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports